/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { TherapistService } from './therapist.service';
import { SessionRewardLedgerGridRequest } from '../models/ledger/sessionLedgerReqRes';
import {
  AdminAddRewardToLedger,
  AdminMakePayoutToExpertsRequest,
  ConsolidatedRewardExportPayload,
  LedgerType,
} from './rewards.service';
import { Observable } from 'rxjs';
import { NetworkUtilsService, URL_DICT } from 'projects/app-core/src/service/network-utils.service';

@Injectable({
  providedIn: 'root'
})
export class SessionRewardsService {

  constructor(private therapistService: TherapistService , private api: NetworkUtilsService) {}
  
    rewardGrid(request: SessionRewardLedgerGridRequest) {
      return this.therapistService.getSessionRewardGrid(request);
    }
  
    makePayout(request: AdminMakePayoutToExpertsRequest) : Observable<any> {
       return this.api.post(URL_DICT.adminMakePayment + LedgerType.SESSION, request);
    }
  
    addRewardToLedger(request: AdminAddRewardToLedger) : Observable<any> {
   return this.api.post(URL_DICT.addRewardToLedger + LedgerType.SESSION, request);
    }

    public getAmountForPayment(toDate: number , userId: string) {
      return this.api.post<{amount: number}>(URL_DICT.getAmountForPayment + LedgerType.SESSION, { toDate , userId});
    }

    public consolidateRewardsExport(fromDate: number, toDate: number) {
      return this.api.post<ConsolidatedRewardExportPayload>(
        URL_DICT.adminConsolidateRewardsExport,
        { fromDate, toDate },
      );
    }
}
